export const createInputElement = (attributes = {}, styles = {}) => {
  const input = document.createElement("input");
  Object.entries(attributes).forEach(([key, value]) => {
    input.setAttribute(key, value);
  });
  Object.entries(styles).forEach(([key, value]) => {
    console.log(key, value);
    input.style[key] = value;
  });
  return input;
};

export const createSelectElement = (
  attributes = {},
  options = [],
  styles = {},
) => {
  const select = document.createElement("select");
  Object.entries(attributes).forEach(([key, value]) => {
    select.setAttribute(key, value);
  });
  options.forEach(({ value, label }) => {
    const option = document.createElement("option");
    option.value = value;
    option.textContent = label;
    select.appendChild(option);
  });
  Object.entries(styles).forEach(([key, value]) => {
    console.log(key, value);
    select.style[key] = value;
  });
  return select;
};
